module.exports = __webpack_public_path__ + "static/media/S (201).6c3a6893.jpg";